module.exports = __webpack_public_path__ + "img/brand (11).5a51a1a2.svg";